<template>
    <media-library-renderless
        ref="mediaLibraryRenderless"
        :initial-value="initialValue"
        :validation-errors="validationErrors"
        :route-prefix="routePrefix"
        :validation-rules="validationRules"
        :translations="translations"
        :before-upload="beforeUpload"
        :after-upload="afterUpload"
        :name="name"
        :max-items="computedMaxItems"
        :max-size-for-preview-in-bytes="maxSizeForPreviewInBytes"
        :vapor="vapor"
        :vapor-signed-storage-url="vaporSignedStorageUrl"
        :upload-domain="uploadDomain"
        :with-credentials="withCredentials"
        @changed="$emit('change', $event)"
        @is-ready-to-submit-change="$emit('is-ready-to-submit-change', $event)"
        @has-uploads-in-progress-change="$emit('has-uploads-in-progress-change', $event)"
        v-slot="{
            state,
            removeMedia,
            getImgProps,
            getCustomPropertyInputProps,
            getCustomPropertyInputListeners,
            getCustomPropertyInputErrors,
            getNameInputProps,
            getNameInputListeners,
            getNameInputErrors,
            getDropZoneProps,
            getDropZoneListeners,
            getFileInputProps,
            getFileInputListeners,
            replaceMedia,
            getErrors,
            clearObjectErrors,
            clearInvalidMedia,
        }">
        <icons/>

        <div :class="`media-library media-library-multiple
      ${state.media.length == 0 ? 'media-library-empty' : 'media-library-filled'}
      ${sortable && 'media-library-sortable'}`">
            <list-errors
                :invalid-media="state.invalidMedia"
                :top-level-errors="validationErrors[name]"
                @cleared="clearInvalidMedia()"
            />

            <div v-show="!computedMaxItems || state.media.length < computedMaxItems" class="media-library-uploader">
                <uploader
                    :multiple="multiple"
                    v-bind="{ ...getDropZoneProps(), ...getFileInputProps() }"
                    v-on="{ ...getDropZoneListeners(), ...getFileInputListeners() }"
                    add
                    :file-type-help-text="fileTypeHelpText"
                />
            </div>

            <component
                :is="sortable ? 'draggable' : 'div'"
                :list="state.media"
                v-show="state.media && state.media.length"
                class="media-library-items"
                handle=".dragula-handle"
                @update="handleSortEnd">
                <div
                    v-for="object in state.media"
                    class="media-library-item media-library-item-row"
                    :data-media-library-uuid="object.attributes.uuid">
                    <div v-if="sortable" class="dragula-handle media-library-row-drag">
                        <icon v-if="state.media.length" icon="drag"/>
                    </div>

                    <v-thumb :uploadInfo="object.upload"
                           :validation-rules="validationRules"
                           :img-props="getImgProps(object)"
                           @replaced="replaceMedia(object, $event)"/>

                    <item-errors v-if="getErrors(object).length"
                                 :object-errors="getErrors(object)"
                                 @back="clearObjectErrors(object)"/>

                    <template v-else>
                        <slot name="properties" :object="object">
                            <div class="media-library-properties media-library-properties-fixed">
                                <div v-if="object.attributes.name" class="media-library-property">
                                    {{ object.attributes.name }}
                                </div>

                                <div v-if="object.attributes.extension" class="media-library-property">
                                    {{ object.attributes.extension.toUpperCase() }}
                                </div>

                                <div v-if="object.attributes.size" class="media-library-property">
                                    {{ getHummanSize(object.attributes.size) }}
                                </div>
                            </div>
                        </slot>
                    </template>

                    <div class="media-library-row-remove" @click.stop="remove(object)" dusk="remove">
                        <icon icon="remove"/>
                    </div>
                </div>
            </component>

            <hidden-fields :name="name" :media-state="state.media"/>
        </div>
    </media-library-renderless>
</template>

<script>
import {VueDraggableNext} from 'vue-draggable-next';
import {
    DropZone,
    HiddenFields,
    Icon,
    Icons,
    ItemErrors,
    ListErrors,
    MediaLibraryRenderless,
    Uploader,
} from 'media-library-pro-vue3';

import VThumb from './VThumb';
import {getHummanSize} from "../../helpers/General";

export default {
    props: {
        name: {required: false, type: String},
        initialValue: {required: false, type: [Array, Object]},
        validationErrors: {default: () => ({}), type: [Object, Array]},
        routePrefix: {required: false, type: String},
        translations: {
            default: () => {
            }, type: Object
        },
        validationRules: {required: false, type: Object},
        multiple: {default: true, type: Boolean},
        sortable: {default: true, type: Boolean},
        maxItems: {required: false, type: Number},
        maxSizeForPreviewInBytes: {required: false, type: Number},
        vapor: {required: false, type: Boolean},
        vaporSignedStorageUrl: {required: false, type: String},
        uploadDomain: {required: false, type: String},
        withCredentials: {required: false, type: Boolean},
        fileTypeHelpText: {required: false, type: String},
        beforeUpload: {
            default: () => {
            }, type: Function
        },
        afterUpload: {
            default: () => {
            }, type: Function
        },
    },
    emits: [
        'change',
        'is-ready-to-submit-change',
        'has-uploads-in-progress-change',
        'isReadyToSubmitChange',
        'hasUploadsInProgressChange',
    ],
    components: {
        draggable: VueDraggableNext,
        MediaLibraryRenderless,
        HiddenFields,
        DropZone,
        ListErrors,
        ItemErrors,
        Icons,
        Icon,
        VThumb,
        Uploader,
    },
    data: () => ({
        mediaLibrary: null,
        window,
        hola: "ad"
    }),
    computed: {
        computedMaxItems() {
            return this.multiple ? this.maxItems : 1;
        },
    },
    mounted() {
        this.mediaLibrary = this.$refs.mediaLibraryRenderless.mediaLibrary;
    },
    methods: {
        getHummanSize,
        remove(object) {
            this.mediaLibrary.removeMedia(object.attributes.uuid);

            this.$emit('removed', null)
        },
        handleSortEnd(event) {
            this.$refs.mediaLibraryRenderless.setOrder(
                Array.from(event.from.children || []).map((element) => {
                    return element.getAttribute('data-media-library-uuid');
                }),
                false
            );
        },
    },
};
</script>
